import reduxActions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  talents: null,
  filters: [],
  loading: false,
  total: 0,
  actions: [],
  bulk_actions: [],
  bulkFormRequested: false,
};

function sortFilterOptions(filters) {
  return filters?.map(filter => {
    if (filter.key === 'state' && filter?.properties?.options) {
      filter.properties.options = filter.properties.options
        .filter(option => option && option.name)
        .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }

    return filter;
  });
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, savedSearches, bulk_actions, actions } = payload;
  const talents = data;

  return {
    ...state,
    talents,
    total,
    filteredTotal,
    filters: sortFilterOptions(filters),
    loading: false,
    savedSearches,
    bulk_actions,
    actions,
  };
}

function onBulkFormRequestSuccess(state) {
  return {
    ...state,
    bulkFormRequested: true,
  };
}

function onCloseBulkRequestModal(state) {
  return {
    ...state,
    bulkFormRequested: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [reduxActions.LOAD]: onLoad,
  [reduxActions.LOAD_SUCCESS]: onLoadSuccess,
  [reduxActions.BULK_FORM_REQUEST_SUCCESS]: onBulkFormRequestSuccess,
  [reduxActions.CLOSE_BULK_REQUEST_MODAL]: onCloseBulkRequestModal,
  [reduxActions.CLEAR_STORE]: onClearStore,
});
